import { createSlice } from "@reduxjs/toolkit";
import {
  getMInvoices,
  getMInvoiceByNumber,
  addNewMInvoice,
  updateMInvoice,
  deleteMInvoice,
} from "./thunk";

export const initialState = {
  minvoices: [],
  error: {},
  isMLoading: false,
  isMInvoicesSuccess: false,
  isMInvoicesFailed: false,

  minvoiceSpecial: [],
  isMSpecialLoading: false,
  isMInvoiceSpecialSuccess: false,
  isMInvoiceSpecialFail: false,
};

const minvoiceSlice = createSlice({
  name: "minvoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getInvoices/ ]=======================================
    builder.addCase(getMInvoices.pending, (state) => {
      state.isMLoading = true;
      state.isMInvoicesSuccess = false;
      state.error = null;
    });
    builder.addCase(getMInvoices.fulfilled, (state, action) => {
      state.isMLoading = false;
      state.isMInvoicesSuccess = true;
      state.minvoices = action.payload;
    });
    builder.addCase(getMInvoices.rejected, (state, action) => {
      state.isMLoading = false;
      state.isMInvoicesSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewMInvoice.fulfilled, (state, action) => {
      state.minvoices.push(action.payload);
      state.isMInvoiceAdd = true;
      state.isMInvoiceAddFail = false;
    });

    builder.addCase(addNewMInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isMInvoiceAdd = false;
      state.isMInvoiceAddFail = true;
    });

    builder.addCase(updateMInvoice.fulfilled, (state, action) => {
      state.minvoices = state.minvoices.map((minvoice) =>
        minvoice._id.toString() === action.payload._id.toString()
          ? { ...minvoice, ...action.payload }
          : minvoice
      );
      state.isMInvoiceUpdate = true;
      state.isMInvoiceUpdateFail = false;
    });

    builder.addCase(updateMInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isMInvoiceUpdate = false;
      state.isMInvoiceUpdateFail = true;
    });

    builder.addCase(deleteMInvoice.fulfilled, (state, action) => {
      state.minvoices = (state.minvoices || []).filter(
        (minvoice) => minvoice._id.toString() !== action.payload.id.toString()
      );

      state.isMInvoiceDelete = true;
      state.isMInvoiceDeleteFail = false;
    });

    builder.addCase(deleteMInvoice.rejected, (state, action) => {
      state.error = action.payload.error || null;
      state.isMInvoiceDelete = false;
      state.isMInvoiceDeleteFail = true;
    });

    builder.addCase(getMInvoiceByNumber.pending, (state) => {
      state.isMSpecialLoading = true;
      state.isMInvoiceSpecialSuccess = false;
      state.error = null;
    });
    builder.addCase(getMInvoiceByNumber.fulfilled, (state, action) => {
      state.isMLoading = false;
      state.isMInvoiceSpecialSuccess = true;
      state.minvoiceSpecial = action.payload;
    });
    builder.addCase(getMInvoiceByNumber.rejected, (state, action) => {
      state.isMLoading = false;
      state.isMInvoiceSpecialSuccess = false;
      state.error = action.error.message;
    });
  },
});

export default minvoiceSlice.reducer;
